// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__content-jRVlU {
  grid-template-columns: repeat(auto-fill, 160px);
}
.sunzi__content-jRVlU .sunzi__card-MF_5j {
  border: 1px solid rgba(0, 0, 0, 0.06);
  padding: 7px;
}
.sunzi__content-jRVlU .sunzi__card-MF_5j.sunzi__selected-card-QUqeS {
  border: 2px solid var(--sunzi-theme-color);
  padding: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/RelativeProduct/style.module.less"],"names":[],"mappings":"AAAA;EACE,+CAAA;AACF;AAFA;EAGI,qCAAA;EACA,YAAA;AAEJ;AADI;EACE,0CAAA;EACA,YAAA;AAGN","sourcesContent":[".content {\n  grid-template-columns: repeat(auto-fill, 160px);\n  .card {\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    padding: 7px;\n    &.selected-card {\n      border: 2px solid var(--sunzi-theme-color);\n      padding: 6px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `sunzi__content-jRVlU`,
	"card": `sunzi__card-MF_5j`,
	"selected-card": `sunzi__selected-card-QUqeS`,
	"selectedCard": `sunzi__selected-card-QUqeS`
};
export default ___CSS_LOADER_EXPORT___;
